import React, { Component } from 'react';
import { storage } from '../firebase/index';
import { db } from '../firebase/index';

class ImageUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      url: '',
      images: []
    }
    this.handleChange = this.handleChange
  }

  handleChange = (e) => {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      this.setState(() => ({image}));
    }
  }
  handleUpload = () => {
    const {image} = this.state;
    // Create a storage ref
    const uploadTask = storage.ref(`imgs/${image.name}`).put(image)
    uploadTask.on('state_changed', 
    (snapshot) => {
      // progress function
    }, 
    (error) => {
      // error function
    },
    () => {
      // complete function
      storage.ref('imgs').child(image.name).getDownloadURL().then((url) => {
        console.log(url);
        this.setState({url});
      })
    });
    //Upload file
  
  }

  render(){
    const style = {
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    };
    
    let imgList = [];
    let elemList = [];
    db.collection("images").get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        const url = doc.data().url;
        imgList.push(url);
      })
    }).then(() => {
      elemList = imgList.map((elem, index) => {
        return <img src={elem} key={index} alt="from store" height="200px"/>;
      });
    }).then(() => {
      this.setState({images: elemList});
    });

    
    const { images } = this.state;

    return(
      <div style={style}>
        <input type="image" onChange={this.handleChange} alt="upload image"/>
        <button onClick={this.handleUpload}>Upload</button>
        <br />
        <img src={this.state.url || 'https://via.placeholder.com/150'} alt="uploaded images" height="200px" />
        <div className="">
          {images}
        </div>
      </div>
    );
  }
}
export default ImageUpload;